import _ from 'lodash'

import CONSTANTS from 'core/data-model/constants/values'
import { createSelector } from 'reselect'
import { getDisplayProducts } from 'quick-quote/product-selection/selectors'
import { getAge } from 'quick-quote/insured-information/selectors'

import { isValidAge } from 'core/service/insured/birthdate'

export const getSelectableProductUltimateGrowth = createSelector(getAge, getDisplayProducts, (age, products) => {
  const productGroup = _.filter(products, (product) =>
    _.includes(CONSTANTS.ULTIMATE_GROWTH_CODE_GROUP, _.get(product, 'code'))
  )
  const validProducts = _.filter(productGroup, (product) => isValidAge(age.value, age.unit, _.get(product, 'entryAge')))
  const validProductCodes = validProducts.map((product) => product.code)

  return validProductCodes
})

export const getSelectableProductGlobalIndex = createSelector(getAge, getDisplayProducts, (age, products) => {
  const productGroup = _.filter(products, (product) =>
    _.includes(Object.values(CONSTANTS.GLOBAL_INDEX_16_6_CODE), _.get(product, 'code'))
  )
  const validProducts = _.filter(productGroup, (product) => isValidAge(age.value, age.unit, _.get(product, 'entryAge')))
  const validProductCodes = validProducts.map((product) => product.code)

  return validProductCodes
})

export const getSelectableProductGlobalIndex25_5 = createSelector(getAge, getDisplayProducts, (age, products) => {
  const productGroup = _.filter(products, (product) =>
    _.includes(Object.values(CONSTANTS.INDEX_LINKED_25_5_CODE), _.get(product, 'code'))
  )
  const validProducts = _.filter(productGroup, (product) => isValidAge(age.value, age.unit, _.get(product, 'entryAge')))
  const validProductCodes = validProducts.map((product) => product.code)

  return validProductCodes
})

export const getSelectableProductGlobalIndex15_8 = createSelector(getAge, getDisplayProducts, (age, products) => {
  const productGroup = _.filter(products, (product) =>
    _.includes(Object.values(CONSTANTS.INDEX_LINKED_15_8_CODE), _.get(product, 'code'))
  )
  const validProducts = _.filter(productGroup, (product) => isValidAge(age.value, age.unit, _.get(product, 'entryAge')))
  const validProductCodes = validProducts.map((product) => product.code)

  return validProductCodes
})

export const getSelectedProductValidOrDefault = (selectableProducts, selectedProduct) => {
  // if current is not valid return the first valie
  return selectableProducts.includes(selectedProduct) ? selectedProduct : selectableProducts[0]
}
